import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedPopupContentComponent } from "./med-popup-content.component";
import { MedDirectiveSharedModule } from "../../../directives/med-directive-shared.module";

@NgModule({
  declarations: [
    MedPopupContentComponent,
  ],
  imports: [
    CommonModule,
    MedDirectiveSharedModule,
  ],
  exports: [
    MedPopupContentComponent,
  ],
})
export class MedPopupContentModule { }
